import styled from 'styled-components';

/** Says the two halves are alternatives without hiding either one. */
export const AndOrDivider = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing(1.5)};
  margin: ${(props) => props.theme.spacing(2, 0)};
  color: ${(props) => props.theme.palette.text.secondary};
  font-size: ${(props) => props.theme.typography.caption.fontSize}px;
  letter-spacing: 0.08em;

  &::before,
  &::after {
    content: '';
    flex: 1 1 auto;
    height: 1px;
    background-color: ${(props) => props.theme.palette.divider};
  }
`;

/** The Form picker and its note, above the block whose units it sets. */
export const FormPicker = styled.div`
  width: 100%;
  margin-bottom: ${(props) => props.theme.spacing(1.5)};
`;
